import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDownloadAgreement } from "../../application/hooks/useDownloadAgreement";
import { authTextButtonStyle } from "../theme/authTextButtonStyle";

const DownloadAgreement = () => {
  const { t } = useTranslation("auth");
  const { downloadAgreement, loading } = useDownloadAgreement();
  const [error, setError] = useState("");

  const handleDownload = async () => {
    try {
      setError("");
      await downloadAgreement();
    } catch (err) {
      setError(err instanceof Error ? err.message : t("downloadAgreement.error"));
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="text-lg font-bold text-center">{t("downloadAgreement.title")}</div>

      <div className="text-md text-gray-400 text-center">
        {t("downloadAgreement.description")}
      </div>

      <button
        type="button"
        onClick={handleDownload}
        disabled={loading}
        className="cursor-pointer text-center text-primary disabled:cursor-not-allowed disabled:opacity-50"
        style={authTextButtonStyle}
      >
        {loading ? t("downloadAgreement.downloading") : t("downloadAgreement.download")}
      </button>

      {error && <p className="text-sm text-red-500 text-center">{error}</p>}
    </div>
  );
};

export default DownloadAgreement;
